import _ from 'underscore';

import { PILOTS } from './pilot-utils';
import { WEBSITE_SOURCE_DATA_KEY_MAPPING } from './site-config-structure';

const config = {
  header: {
    required: true,
    order: 0,
  },
  introduction: {
    required: true,
    order: 1,
  },
  callToAction: {
    required: true,
    order: 2,
  },
  coverImage: {
    required: true,
    order: 3,
  },
  summary: {
    required: false,
    navTitle: _TL_('About Us'),
    order: 4,
  },
  professionalService: {
    required: false,
    navTitle: _TL_('Services'),
    order: 5,
    hideNavWhenEmpty: true,
    hideContainerWhenEmpty: true,
    pilot: PILOTS.isSmartPageProfessionalServicesEnabled,
    wsdKey: WEBSITE_SOURCE_DATA_KEY_MAPPING.Services,
  },
  video: {
    required: false,
    order: 6,
    pilot: PILOTS.isSmartPageVideoSectionEnabled,
  },
  update: {
    required: false,
    navTitle: _TL_('Updates'),
    order: 7,
    hideNavWhenEmpty: true,
    hideContainerWhenEmpty: true,
    dataProp: 'updates',
  },
  review: {
    required: false,
    navTitle: _TL_('Testimonials'),
    order: 8,
    hideNavWhenEmpty: true,
    hideContainerWhenEmpty: true,
    dataProp: 'reviews',
  },
  gallery: {
    required: false,
    navTitle: _TL_('Gallery'),
    order: 9,
    hideNavWhenEmpty: true,
    hideContainerWhenEmpty: true,
    dataProp: 'photos',
  },
  contact: {
    required: true,
    navTitle: _TL_('Contact Us'),
    order: 10,
  },
  businessHours: {
    required: false,
    // For temp solution, do not show this in menu
    // navTitle: _TL_('Business Hours'),
    order: 11,
    pilot: PILOTS.isSmartPageBusinessHourSectionEnabled,
  },
  socialLinks: {
    required: false,
    hideContainerWhenEmpty: true,
    order: 12,
  },
  footer: {
    required: true,
    order: 13,
  },
};

// Complete components config
export const componentsConfig = _.mapObject(config, (val, key) => ({
  ...val,
  type: key,
  required: !!val.required,
}));
